import { StoreState } from '@/core/models/store.interface';
import i18n from '@/i18n';
import { Module } from 'vuex';
import boardImportService from './board-import.service';

export interface BoardImportState { }

const BoardImportStore: Module<BoardImportState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async postBoardStructure(
         context,
         { board_id, file, should_overwrite_existing_shifts }: { board_id: number; file: File; should_overwrite_existing_shifts: boolean },
      ) {
         const formData = new FormData();
         formData.append('file', file);
         formData.append('board_id', `${board_id}`);
         formData.append('should_overwrite_existing_shifts', `${should_overwrite_existing_shifts}`);

         const NOTIFICATION_BUSY = await context.dispatch(
            'addNotification',
            {
               notification: {
                  type: 'info',
                  message: `${i18n.global.t('board.import_busy')}`,
                  duration: Infinity,
                  spinner: true,
               },
            },
            { root: true },
         );

         return await boardImportService
            .postBoardStructure(formData)
            .then((response) => {
               context.dispatch(
                  'addNotification',
                  {
                     notification: {
                        type: 'success',
                        message: `${i18n.global.t('services.import_successful')}`,
                     },
                  },
                  { root: true },
               );
               return response;
            })
            .finally(() => {
               context.dispatch('removeNotification', { notification: NOTIFICATION_BUSY }, { root: true });
            });
      },
   },
};

export default BoardImportStore;
